// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"09c6f45696b5f1a3","node_modules_canvg_lib_index_es_js":"43dd4a4e76afd18a"}[chunkId] + ".js";
};